import type { DatabaseActionType } from "../../../../core/modules/Database/databaseTypes";
import MultiIdsList from "@/components/MultiIdsList";

export default function ActionIdsTab({ action }: { action: DatabaseActionType }) {
    return (
        <div className="flex flex-col gap-5">
            <div>
                <p className="text-[11px] font-mono font-bold uppercase tracking-widest text-slate-600 mb-3">
                    Player Identifiers
                </p>
                <MultiIdsList type='id' src='action' list={action.ids} />
            </div>
            <div>
                <p className="text-[11px] font-mono font-bold uppercase tracking-widest text-slate-600 mb-3">
                    Hardware IDs
                </p>
                <MultiIdsList
                    type='hwid'
                    src='action'
                    list={('hwids' in action && action.hwids) ? action.hwids : []}
                />
            </div>
        </div>
    );
}
